import { render, staticRenderFns } from "./salemanCustomerComplaints.vue?vue&type=template&id=7a58309a&scoped=true"
import script from "./salemanCustomerComplaints.vue?vue&type=script&lang=js"
export * from "./salemanCustomerComplaints.vue?vue&type=script&lang=js"
import style0 from "./salemanCustomerComplaints.vue?vue&type=style&index=0&id=7a58309a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a58309a",
  null
  
)

export default component.exports